import Chart from 'chart.js/auto';

export class CompoundingCalculator {
  constructor() {
    this.form = document.querySelector('.js-compounding-calc-form');
    this.resultsDiv = document.querySelector('.js-calculation-results');
    // Form fields
    this.starting = 0;
    this.years = 0;
    this.months = 0;
    this.percent = 0;
    this.period = '';
    this.accountCurrency = '';

    // Chart variables
    this.chartYearly;
    this.chartMonthly;

    this.ctxYearly = document.getElementById('chart-yearly');
    this.ctxMonthly = document.getElementById('chart-monthly');

    this.chartDataYearly = {
      labels: [],
      datasets: [
        {
          label: 'Value',
          data: [],
          backgroundColor: '#2c7bfd',
        },
      ],
    };

    this.chartDataMonthly = {
      labels: [],
      datasets: [
        {
          label: 'Value',
          data: [],
          backgroundColor: '#2c7bfd',
        },
      ],
    };

    this.chartConfigYearly = {
      type: 'bar',
      data: this.chartDataYearly,
      options: {
        layout: {
          padding: {
            bottom: 0,
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Year',
            },
            grid: {
              display: true,
              drawOnChartArea: false,
              drawTicks: false,
            },
            border: {
              display: true,
              drawBorder: false,
            },
          },
          y: {
            beginAtZero: true,
            grid: {
              display: true,
              drawOnChartArea: false,
              drawTicks: false,
            },
            border: {
              display: true,
              drawBorder: false,
            },
          },
        },
        plugins: {
          title: {
            display: true,
            position: 'top',
            text: 'Yearly Projection',
            font: {
              weight: 'bold',
              size: 18,
            },
            padding: {
              top: 10,
              bottom: 30,
            },
          },
          legend: {
            display: false,
          },
        },
      },
    };

    this.chartConfigMonthly = {
      type: 'bar',
      data: this.chartDataMonthly,
      options: {
        layout: {
          padding: {
            bottom: 0,
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Year',
            },
            grid: {
              display: true,
              drawOnChartArea: false,
              drawTicks: false,
            },
            border: {
              display: true,
              drawBorder: false,
            },
          },
          y: {
            beginAtZero: true,
            grid: {
              display: true,
              drawOnChartArea: false,
              drawTicks: false,
            },
            border: {
              display: true,
              drawBorder: false,
            },
          },
        },
        plugins: {
          title: {
            display: true,
            position: 'top',
            text: 'Monthly Projection',
            font: {
              weight: 'bold',
              size: 18,
            },
            padding: {
              top: 10,
              bottom: 30,
            },
          },
          legend: {
            display: false,
          },
        },
      },
    };

    // Binding
    this.calculateResults = this.calculateResults.bind(this);
    this.updateStats = this.updateStats.bind(this);
    this.updateSummary = this.updateSummary.bind(this);
    this.updateYearlyTable = this.updateYearlyTable.bind(this);
    this.updateMonthlyTable = this.updateMonthlyTable.bind(this);
    this.newChart = this.newChart.bind(this);
    this.updateChart = this.updateChart.bind(this);
    this.initChart = this.initChart.bind(this);
  }

  calculateResults() {
    this.starting = Number(this.form.starting.value);
    this.years = Number(this.form.years.value);
    this.months = Number(this.form.months.value);
    this.percent = Number(this.form.percent.value);
    this.period = this.form.period.value;
    this.accountCurrency = this.form.currency.value;

    this.resultsDiv.classList.add('show');
    setTimeout(() => {
      window.scrollTo({ top: this.resultsDiv.offsetTop, behavior: 'smooth' });
    }, 500);

    //     // future value
    let t;
    let n;
    const r = this.percent / 100;
    if (this.period === 'monthly') {
      n = 12;
      t = this.years * 12 + this.months;
    } else if (this.period === 'yearly') {
      n = 1;
      t = this.years + this.months / 12;
    }

    const futureValue = this.starting * Math.pow(1 + r / n, n * t);
    const totalInterest = futureValue - this.starting;

    // Set the monthlyButton selector to access inside the below if condition
    // durationButtons[0] will be monthly
    // durationButtons[1] will be yearly
    const durationButtons = document.querySelectorAll('.btn-tabs');
    const navPanels = document.querySelectorAll('.tab-panel');

    const monthlyBalance = [];
    const monthlyTotalEarnings = [];
    const monthlyEarnings = [];

    const yearlyBalance = [];
    const yearlyTotalEarnings = [];
    const yearlyEarnings = [];

    if (this.period === 'monthly') {
      // Figures for monthly table
      const monthlyTime = this.years * 12 + this.months;

      for (let i = 0; i <= monthlyTime; i++) {
        if (i === 0) {
          monthlyEarnings.push(0);
          monthlyTotalEarnings.push(0);
          monthlyBalance.push(this.starting);
        } else {
          const tempEarnings = monthlyBalance[i - 1] * r;
          monthlyEarnings.push(tempEarnings);
          monthlyTotalEarnings.push(
            monthlyEarnings[i] + monthlyTotalEarnings[i - 1]
          );
          monthlyBalance.push(monthlyBalance[i - 1] + monthlyEarnings[i]);
        }
      }

      // If monthly we can display both yearly and monthly tables - and make sure the button is showing
      this.updateYearlyTable(
        monthlyBalance,
        monthlyTotalEarnings,
        monthlyEarnings
      );
      this.updateMonthlyTable(
        monthlyBalance,
        monthlyTotalEarnings,
        monthlyEarnings
      );
      navPanels.forEach((panel) => {
        panel.classList.remove('active');
      });
      durationButtons.forEach((tab) => {
        tab.classList.remove('active');
      });
      navPanels[0].classList.add('active');
      durationButtons[0].style.display = 'block';
      durationButtons[0].classList.add('active');
    } else if (this.period === 'yearly') {
      // Figures for yearly table
      const yearlyTime = this.years + this.months / 12;

      for (let i = 0; i <= yearlyTime; i++) {
        if (i === 0) {
          yearlyEarnings.push(0);
          yearlyTotalEarnings.push(0);
          yearlyBalance.push(this.starting);
        } else {
          const tempEarnings = yearlyBalance[i - 1] * r;
          yearlyEarnings.push(tempEarnings);
          yearlyTotalEarnings.push(
            yearlyEarnings[i] + yearlyTotalEarnings[i - 1]
          );
          yearlyBalance.push(yearlyBalance[i - 1] + yearlyEarnings[i]);
        }
      }

      if (this.months > 0 && this.years > 0) {
        const finalYears = yearlyTime - this.years;
        const finalPercent = r * finalYears;
        const tempEarnings =
          yearlyBalance[yearlyBalance.length - 1] * finalPercent;
        yearlyEarnings.push(tempEarnings);
        yearlyTotalEarnings.push(
          yearlyEarnings[yearlyEarnings.length - 1] +
            yearlyTotalEarnings[yearlyTotalEarnings.length - 1]
        );
        yearlyBalance.push(
          yearlyBalance[yearlyBalance.length - 1] +
            yearlyEarnings[yearlyEarnings.length - 1]
        );
      }

      // If yearly, we only display the yearly table and hide the monthly button
      this.updateYearlyTable(
        yearlyBalance,
        yearlyTotalEarnings,
        yearlyEarnings
      );
      navPanels.forEach((panel) => {
        panel.classList.remove('active');
      });
      durationButtons.forEach((tab) => {
        tab.classList.remove('active');
      });
      navPanels[1].classList.add('active');
      durationButtons[0].style.display = 'none';
      durationButtons[1].classList.add('active');
    }

    const cagr = ((futureValue / this.starting) ** (1 / (t / n)) - 1) * 100;

    this.updateStats(futureValue, totalInterest, cagr);
    this.updateSummary();

    // Check if chart already exists
    if (
      this.ctxMonthly.$chartjs === undefined ||
      this.ctxYearly.$chartjs === undefined
    ) {
      if (this.period === 'monthly') {
        this.newChart(monthlyBalance);
      } else if (this.period === 'yearly') {
        this.newChart(yearlyBalance);
      }
    } else {
      if (this.period === 'monthly') {
        this.updateChart(monthlyBalance);
      } else if (this.period === 'yearly') {
        this.updateChart(yearlyBalance);
      }
    }
  }

  updateStats(futureValue, totalInterest, cagr) {
    const initialFields = document.querySelectorAll(
      '.js_compound_stats_initial'
    );
    const cagrFields = document.querySelectorAll('.js_compound_stats_cagr');
    const futureFields = document.querySelectorAll(
      '.js_compound_stats_future-value'
    );
    const totalFields = document.querySelectorAll('.js_compound_stats_total');
    initialFields.forEach((element) => {
      element.innerText = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: this.accountCurrency,
      }).format(this.starting.toFixed(0));
    });
    cagrFields.forEach((element) => {
      element.innerText = `${cagr.toFixed(2)}%`;
    });
    futureFields.forEach((element) => {
      if (futureValue >= 9999999999) {
        futureValue = 9999999999;
        element.innerText = `${new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.accountCurrency,
        }).format(futureValue.toFixed(0))}`;
      } else {
        element.innerText = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.accountCurrency,
        }).format(futureValue.toFixed(0));
      }
    });
    totalFields.forEach((element) => {
      if (totalInterest >= 9999999999) {
        totalInterest = 9999999999;
        element.innerText = `${new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.accountCurrency,
        }).format(totalInterest.toFixed(0))}`;
      } else {
        element.innerText = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.accountCurrency,
        }).format(totalInterest.toFixed(0));
      }
    });
  }

  updateSummary() {
    let timeString;
    if (this.years >= 2) {
      timeString = `${this.years} years`;
    } else if (this.years === 1) {
      timeString = `${this.years} year`;
    } else if (this.years === 0) {
      timeString = '';
    }
    if (this.years >= 1) {
      if (this.months === 1) {
        timeString += ` and ${this.months} month`;
      } else if (this.months >= 2) {
        timeString += ` and ${this.months} months`;
      }
    } else {
      if (this.months === 1) {
        timeString += `${this.months} month`;
      } else if (this.months >= 2) {
        timeString += `${this.months} months`;
      }
    }
    const initialDeposit = document.querySelectorAll(
      '.js_summary-initial-deposit'
    );
    const percentage = document.querySelectorAll('.js_summary-percentage');
    const time = document.querySelectorAll('.js_summary-time');
    const compounding = document.querySelectorAll('.js_summary-compounding');
    initialDeposit.forEach((element) => {
      element.innerText = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: this.accountCurrency,
      }).format(this.starting.toFixed(0));
    });
    percentage.forEach((element) => {
      element.innerText = `${this.percent}% ${
        this.period[0].toUpperCase() + this.period.substring(1)
      }`;
    });
    time.forEach((element) => {
      element.innerText = timeString;
    });
    compounding.forEach((element) => {
      element.innerText =
        this.period[0].toUpperCase() + this.period.substring(1);
    });
  }

  updateYearlyTable(balance, totalEarnings, earnings) {
    const table = document.getElementById('yearly-table-body');
    const rows = document.querySelectorAll('#yearly-table-body tr').length;
    let row;
    const formatOptions = {
      style: 'currency',
      currency: this.accountCurrency,
    };
    for (let i = rows - 1; i >= 0; i--) {
      table.deleteRow(i);
    }

    let i = 0;
    let j = 0;
    if (this.period === 'monthly') {
      while (i < balance.length) {
        if (j < balance.length) {
          let largeEarnings = '';
          let largeTotal = '';
          let largeBalance = '';

          if (earnings[j] >= 999999999999) {
            earnings[j] = 999999999999;
            largeEarnings = '+';
          }
          const formattedEarnings =
            new Intl.NumberFormat('en-US', formatOptions).format(
              earnings[j].toFixed(2)
            ) + largeEarnings;

          if (totalEarnings[j] >= 999999999999) {
            totalEarnings[j] = 999999999999;
            largeTotal = '+';
          }
          const formattedTotalEarnings =
            new Intl.NumberFormat('en-US', formatOptions).format(
              totalEarnings[j].toFixed(2)
            ) + largeTotal;

          if (balance[j] >= 999999999999) {
            balance[j] = 999999999999;
            largeBalance = '+';
          }
          const formattedBalance =
            new Intl.NumberFormat('en-US', formatOptions).format(
              balance[j].toFixed(2)
            ) + largeBalance;

          row = `
            <tr>
              <td data-label="Year">${
                i == balance.length - 1 ? 'Final' : i
              }</td>
              <td data-label="Earnings">${formattedEarnings}</td>
              <td data-label="Total Earnings">${formattedTotalEarnings}</td>
              <td data-label="Balance">${formattedBalance}</td>
            </tr>
          `;
          table.innerHTML += row;

          j = j + 12;
        }
        i++;
      }
      if (this.years > 0 && this.months > 0) {
        // let formattedEarnings, formattedTotalEarnings, formattedBalance;
        let largeEarnings = '';
        let largeTotal = '';
        let largeBalance = '';

        if (earnings[earnings.length - 1] >= 999999999999) {
          earnings[earnings.length - 1] = 999999999999;
          largeEarnings = '+';
        }
        const formattedEarnings =
          new Intl.NumberFormat('en-US', formatOptions).format(
            earnings[earnings.length - 1].toFixed(2)
          ) + largeEarnings;

        if (totalEarnings[totalEarnings.length - 1] >= 999999999999) {
          totalEarnings[totalEarnings.length - 1] = 999999999999;
          largeTotal = '+';
        }
        const formattedTotalEarnings =
          new Intl.NumberFormat('en-US', formatOptions).format(
            totalEarnings[totalEarnings.length - 1].toFixed(2)
          ) + largeTotal;

        if (balance[balance.length - 1] >= 999999999999) {
          balance[balance.length - 1] = 999999999999;
          largeBalance = '+';
        }
        const formattedBalance =
          new Intl.NumberFormat('en-US', formatOptions).format(
            balance[balance.length - 1].toFixed(2)
          ) + largeBalance;

        row = `
          <tr>
            <td data-label="Year">Final</td>
            <td data-label="Earnings">${formattedEarnings}</td>
            <td data-label="Total Earnings">${formattedTotalEarnings}</td>
            <td data-label="Balance">${formattedBalance}</td>
          </tr>
        `;
        table.innerHTML += row;
      }
    } else if (this.period === 'yearly') {
      while (i < balance.length) {
        let largeTotal = '';

        if (earnings[i] >= 999999999999) {
          earnings[i] = 999999999999;
        }

        const formattedEarnings =
          new Intl.NumberFormat('en-US', formatOptions).format(
            earnings[i].toFixed(2)
          ) + largeTotal;

        if (totalEarnings[i] >= 999999999999) {
          totalEarnings[i] = 999999999999;
          largeTotal = '+';
        }
        const formattedTotalEarnings =
          new Intl.NumberFormat('en-US', formatOptions).format(
            totalEarnings[i].toFixed(2)
          ) + largeTotal;

        if (balance[i] >= 999999999999) {
          balance[i] = 999999999999;
        }
        const formattedBalance =
          new Intl.NumberFormat('en-US', formatOptions).format(
            balance[i].toFixed(2)
          ) + largeTotal;

        row = `
          <tr>
            <td data-label="Year">${i == balance.length - 1 ? 'Final' : i}</td>
            <td data-label="Earnings">${formattedEarnings}</td>
            <td data-label="Total Earnings">${formattedTotalEarnings}</td>
            <td data-label="Balance">${formattedBalance}</td>
          </tr>
        `;
        table.innerHTML += row;

        i++;
      }
    }
  }

  updateMonthlyTable(balance, totalEarnings, earnings) {
    const table = document.getElementById('monthly-table-body');
    const rows = document.querySelectorAll('#monthly-table-body tr').length;
    let row;
    const formatOptions = {
      style: 'currency',
      currency: this.accountCurrency,
    };
    for (let i = rows - 1; i >= 0; i--) {
      table.deleteRow(i);
    }

    table.innerHTML = '';

    for (let i = 0; i < balance.length; i++) {
      // const formattedEarnings, formattedTotalEarnings, formattedBalance;
      let largeEarnings = '';
      let largeTotal = '';
      let largeBalance = '';

      if (earnings[i] >= 999999999999) {
        earnings[i] = 999999999999;
        largeEarnings = '+';
      }
      const formattedEarnings =
        new Intl.NumberFormat('en-US', formatOptions).format(
          earnings[i].toFixed(2)
        ) + largeEarnings;

      if (totalEarnings[i] >= 999999999999) {
        totalEarnings[i] = 999999999999;
        largeTotal = '+';
      }
      const formattedTotalEarnings =
        new Intl.NumberFormat('en-US', formatOptions).format(
          totalEarnings[i].toFixed(2)
        ) + largeTotal;

      if (balance[i] >= 999999999999) {
        balance[i] = 999999999999;
        largeBalance = '+';
      }
      const formattedBalance =
        new Intl.NumberFormat('en-US', formatOptions).format(
          balance[i].toFixed(2)
        ) + largeBalance;

      row = `
        <tr>
          <td data-label="Month">${i == balance.length - 1 ? 'Final' : i}</td>
          <td data-label="Earnings">${formattedEarnings}</td>
          <td data-label="Total Earnings">${formattedTotalEarnings}</td>
          <td data-label="Balance">${formattedBalance}</td>
        </tr>
      `;
      table.innerHTML += row;
    }
  }
  //
  // // Chart functions
  //
  // // Create new chart
  newChart(balance) {
    let i = 0;
    let j = 0;

    if (this.period === 'monthly') {
      while (i < balance.length) {
        if (j < balance.length) {
          this.chartDataYearly.labels.push(i);
          this.chartDataYearly.datasets[0].data.push(balance[j]);
          j = j + 12;
        }
        i++;
      }
      if (this.years > 0 && this.months > 0) {
        this.chartDataYearly.labels.push('Final');
        this.chartDataYearly.datasets[0].data.push(balance[balance.length - 1]);
      }
      for (let i = 0; i < balance.length; i++) {
        if (i == balance.length - 1) {
          this.chartDataMonthly.labels.push('Final');
        } else {
          this.chartDataMonthly.labels.push(i);
        }
        this.chartDataMonthly.datasets[0].data.push(balance[i]);
      }
    } else if (this.period === 'yearly') {
      for (let i = 0; i < balance.length; i++) {
        if (i == balance.length - 1) {
          this.chartDataMonthly.labels.push('Final');
          this.chartDataYearly.labels.push('Final');
        } else {
          this.chartDataMonthly.labels.push(i);
          this.chartDataYearly.labels.push(i);
        }
        this.chartDataMonthly.datasets[0].data.push(balance[i]);
        this.chartDataYearly.datasets[0].data.push(balance[i]);
      }
    }
    this.initChart();
  }

  // // If already existing will need to destroy the existing first, then render new one
  updateChart(balance) {
    // Clear existing charts and reset data
    this.chartYearly.destroy();
    this.chartMonthly.destroy();
    this.chartDataMonthly.labels = [];
    this.chartDataMonthly.datasets[0].data = [];
    this.chartDataYearly.labels = [];
    this.chartDataYearly.datasets[0].data = [];

    // Fill with new data
    let i = 0;
    let j = 0;

    if (this.period === 'monthly') {
      while (i < balance.length) {
        if (j < balance.length) {
          this.chartDataYearly.labels.push(i);
          this.chartDataYearly.datasets[0].data.push(balance[j]);
          j = j + 12;
        }
        i++;
      }
      if (this.years > 0 && this.months > 0) {
        this.chartDataYearly.labels.push('Final');
        this.chartDataYearly.datasets[0].data.push(balance[balance.length - 1]);
      }
      for (let i = 0; i < balance.length; i++) {
        if (i == balance.length - 1) {
          this.chartDataMonthly.labels.push('Final');
        } else {
          this.chartDataMonthly.labels.push(i);
        }
        this.chartDataMonthly.datasets[0].data.push(balance[i]);
      }
    } else if (this.period === 'yearly') {
      for (let i = 0; i < balance.length; i++) {
        if (i == balance.length - 1) {
          this.chartDataMonthly.labels.push('Final');
          this.chartDataYearly.labels.push('Final');
        } else {
          this.chartDataMonthly.labels.push(i);
          this.chartDataYearly.labels.push(i);
        }
        this.chartDataMonthly.datasets[0].data.push(balance[i]);
        this.chartDataYearly.datasets[0].data.push(balance[i]);
      }
    }
    this.initChart();
  }

  initChart() {
    document.getElementById('chart-monthly').style.width = '100%';
    document.getElementById('chart-monthly').style.height = 'auto';
    this.chartMonthly = new Chart(
      document.getElementById('chart-monthly'),
      this.chartConfigMonthly
    );

    document.getElementById('chart-yearly').style.width = '100%';
    document.getElementById('chart-yearly').style.height = 'auto';
    this.chartYearly = new Chart(
      document.getElementById('chart-yearly'),
      this.chartConfigYearly
    );
  }
}
